(() => {
  const data = document.getElementById('xy-order-separation-data');
  if (!data) return;
  let customProducts, customVariants, messages, validData = false;
  try {
    const parsed = JSON.parse(data.textContent);
    messages = parsed;
    customProducts = new Set(parsed.products.map(String));
    customVariants = new Set(parsed.variants.map(String));
    validData = customProducts.size > 0 && customVariants.size > 0;
  } catch (_) {}
  const root = window.Shopify?.routes?.root || '/';
  const approved = new WeakSet();
  let busy = false;
  const showMessage = (form, message) => {
    let notice = form.querySelector('[data-separation-error]');
    if (!notice) {
      notice = document.createElement('p');
      notice.dataset.separationError = '';
      notice.setAttribute('role', 'alert');
      notice.style.cssText = 'color:#9d1d20; padding:1rem; border:1px solid currentColor; margin:1rem 0;';
      form.prepend(notice);
    }
    notice.textContent = message;
  };
  const cart = async () => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      return await response.json();
    } finally { clearTimeout(timer); }
  };
  const classify = items => new Set(items.map(item => customProducts.has(String(item.product_id)) ? 'custom' : 'ready'));
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || approved.has(form)) return;
    const path = new URL(form.action, location.href).pathname;
    const adding = /\/cart\/add\/?$/.test(path);
    const checking = event.submitter?.name === 'checkout';
    if (!adding && !checking) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    try {
      if (!validData) throw new Error('Missing custom product data');
      const types = classify((await cart()).items);
      if (adding) {
        const id = new FormData(form).get('id');
        if (!id) throw new Error('Missing variant');
        const next = customVariants.has(String(id)) ? 'custom' : 'ready';
        if (types.size > 1 || (types.size && !types.has(next))) { showMessage(form, messages.conflict); return; }
      } else if (types.size > 1) { showMessage(form, messages.mixed); return; }
      approved.add(form);
      try { form.requestSubmit(event.submitter || undefined); } finally { approved.delete(form); }
    } catch (_) {
      showMessage(form, messages?.unavailable || 'We could not check your cart. Please try again.');
    } finally { busy = false; }
  }, true);
})();

